import React from "react";
import Banner from "./Banner";
import Trusted from "./Trusted";
import dynamic from "next/dynamic";
const MakeUs = dynamic(() => import("./make-us"),{ssr: true});
const Industry = dynamic(() => import("./industry"),{ssr: true});
const Testimonials = dynamic(() => import("./Review"),{ssr: true});
const CRMSystem = dynamic(() => import("./crm-solutions"),{ssr: true});
const OurApproach = dynamic(() => import("./OurApproach"),{ssr: true});
const LatestBlock = dynamic(() => import("./LatestBlock"),{ssr: true});
const BuildSection = dynamic(() => import("./BuildSection"),{ssr: true});
const TechnologyStack = dynamic(() => import("./TechnologyStack"),{ssr: true});
const Faq = dynamic(() => import("@/Components/pages/blog/detail/detail-post/faq"),{ssr: true});
const CaseStudies = dynamic(() => import("@/Components/pages/TechnologyPage/technologies-new/Client-solution"),{ssr: true});
const MostTrusted = dynamic(() => import("./most-trusted"),{ssr: true});
const Partner = dynamic(() => import("./Partner"),{ssr: true});
const GhostPageDetails = (props: any) => {
  const blocks = props.blocks;
  const renderBlock = (block: any, i: number) => {
    switch (block.__component) {
      case "blocks.service-banner":
        return <Banner key={i} data={block} />;

      case "blocks.2025-home-trusted-by":
        return <Trusted key={i} data={block} />;
      case "blocks.service-architecture":
        return <MakeUs key={i} data={block} />;
      case "blocks.cta":
        return <BuildSection key={i} block={block} />;
      case "blocks.technology-stack":
        return <TechnologyStack key={i} data={block} />;
      case "blocks.latest-technologies":
        return <CRMSystem data={block} isMobile={true} />;
      case "blocks.testimonials":
        return <Testimonials key={i} data={block} />;
      case "blocks.development-expertise":
        return <Industry key={i} data={block} />;
      case "blocks.our-approach":
        return <OurApproach key={i} data={block} />;
      case "blocks.most-trusted":
        return <MostTrusted key={i} block={block} />;
      case "blocks.top-case-studies":
        return <CaseStudies key={i} data={block} viewCase={false} />;
      case "blocks.recognized-partner":
        return <Partner key={i} data={block} />;
      case "blocks.related-articles":
        return <LatestBlock key={i} block={block} />;
      case "blocks.book-consultations":
        return <BuildSection key={i} block={block} />;
      case "blocks.faq":
        return (
          <section
            key={i}
            className="bg-white xl:pb-[90px] md:pb-[80px] pb-[56px]"
          >
            <div className="container mx-auto">
              <Faq items={block} />
            </div>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <main role="main" className="middle-section serives-new-middle pt-0">
      <div className="middle-inner">
        {blocks?.map((block: any, i: number) => renderBlock(block, i))}
      </div>
    </main>
  );
};

export default GhostPageDetails;
